import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { QSRoomsComponent } from './quickstart-rooms.component';

import { SelectRoomComponent } from './select-room/select-room.component';
import { SelectParamsComponent } from './select-params/select-params.component';

export const QUICKSTART_TRIGGERS_ROOMS_ROUTES: Routes = [
  {
    path: 'rooms',
    component: QSRoomsComponent,
    children: [
      {
        path: ':eventId',
        component: SelectRoomComponent
      },
      {
        path: ':eventId/:roomId',
        component: SelectParamsComponent
      }
    ]
  }
];

export const QUICKSTART_ACTIONS_ROOMS_ROUTES: Routes = [
  {
    path: 'rooms',
    component: QSRoomsComponent,
    children: [
      {
        path: ':command',
        component: SelectRoomComponent
      },
      {
        path: ':command/:roomId',
        component: SelectParamsComponent
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-rooms/quickstart-rooms.routes.ts